import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface CourseChaptersCountState {
  count: number;
}

const firstCourseChaptersCount: Module<CourseChaptersCountState, RootState> = {
  namespaced: true,
  state: () => ({
    count: 0,
  }),
  getters: {
    getFirstCourseChaptersCount: state => state.count,
  },
  mutations: {
    setValue(state: CourseChaptersCountState, value: CourseChaptersCountState): void {
      state.count = value.count;
    },
  },
  actions: {},
};

export default firstCourseChaptersCount;
